"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePlatformSdkReactTranslation = usePlatformSdkReactTranslation;
const react_i18next_1 = require("react-i18next");
function usePlatformSdkReactTranslation() {
    return (0, react_i18next_1.useTranslation)('platform-sdk-react');
}
